export default "__VITE_ASSET__BiSnIrUg__"